import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const postBusRoute = ({ courseId, ...data }) => {
  return api.post(`admin/bus-courses-v2/${courseId}/routes`, data);
};

export const usePostBusRouteMutation = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: postBusRoute,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
